import React from "react";
import { AppUploadIcon } from "../../Icon/AppUploadIcon";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const UploadButton = (props: IAppButtonProps) => (
    <AppButton variant="contained" startIcon={<AppUploadIcon />} {...props}>
        {props.children}
    </AppButton>
);
